/** Hindi: personal QR codes. */
export const qr = {
    "qr.mine": "आपका QR कोड",
    "qr.about_worker": "किसी भी फ़ोन के कैमरे से स्कैन करके {name} से काम के लिए पूछिए — कोई ऐप नहीं चाहिए।",
    "qr.about_household": "जो कामगार इसे स्कैन करे, वह सिर्फ़ आपका पहला नाम देखता है और आपके लिए काम करने की पेशकश कर सकता है। उनसे पूछना है या नहीं, यह आप तय करते हैं।",
    "qr.alt": "{name} तक पहुँचाने वाला QR कोड",
    "qr.download": "QR सेव करें",
    "qr.share": "भेजें",
    "qr.shared": "भेज दिया।",
    "qr.share_title": "GigSync पर {name}",
    "qr.share_worker": "GigSync पर {name} से काम के लिए पूछिए।",
    "qr.share_household": "GigSync पर {name} के लिए काम करने की पेशकश कीजिए।",
    "qr.copy": "लिंक कॉपी करें",
    "qr.copied": "लिंक कॉपी हो गया।",
    "qr.copy_failed": "इस फ़ोन ने कॉपी करने नहीं दिया।",
    "qr.new": "नया QR बनाएँ",
    "qr.new_about": "आपका पुराना QR और उसका लिंक तुरंत आप तक पहुँचाना बंद कर देते हैं।",
    "qr.keep": "यही रखें",
    "qr.new_done": "नया QR बन गया। पुराना अब आप तक नहीं पहुँचाता।",
    "qr.scan": "QR स्कैन करें",
    "qr.scan_close": "बंद करें",
    "qr.scan_label": "कैमरा, QR कोड ढूँढ रहा है",
    "qr.camera_why": "QR कोड स्कैन करने के लिए GigSync को कैमरा चाहिए, सिर्फ़ स्कैन करते समय। आपका फ़ोन आगे पूछेगा।",
    "qr.camera_denied": "कैमरे की इजाज़त नहीं मिली। आप फ़ोन के कैमरा ऐप से भी स्कैन कर सकते हैं।",
    "qr.no_camera": "यहाँ इस्तेमाल के लिए कैमरा नहीं है। आप फ़ोन के कैमरा ऐप से भी स्कैन कर सकते हैं।",
    "qr.not_ours": "यह GigSync का QR कोड नहीं है।",
    "qr.person": "QR से मिले",
    "qr.finding": "पता कर रहे हैं कि यह कौन है…",
    "qr.household": "घर",
    "qr.ask": "{name} से काम के लिए पूछें",
    "qr.offer": "{name} के लिए काम करने की पेशकश करें",
    "qr.offered": "भेज दिया। {name} तय करेंगे कि आपसे पूछना है या नहीं।",
    "qr.yours": "यह आपका अपना QR कोड है।",
    "qr.no_card": "{name} का कार्ड अभी बोर्ड पर नहीं है।",
    "qr.worker_to_worker": "घर वाले कामगारों से काम के लिए पूछते हैं। आपका अपना QR उन्हें आप तक पहुँचाता है।",
    "qr.household_to_household": "सिर्फ़ कामगार ही {name} के लिए काम करने की पेशकश कर सकते हैं।",
    "qr.need_card": "पहले अपना कार्ड बोर्ड पर डालें, ताकि {name} देख सकें कि आप क्या काम करते हैं।",
    "qr.ended": "यह QR अब काम नहीं करता। उनसे नया QR दिखाने को कहें।",
    "qr.too_old": "पेशकश पाने के लिए {name} के GigSync को अपडेट चाहिए।",
    "qr.too_many": "इस घंटे बहुत सारे QR कोड देखे गए। थोड़ी देर बाद फिर कोशिश करें।",
    "qr.offered_today": "आप आज {name} के लिए काम करने की पेशकश कर चुके हैं।",
    "qr.worker_limit": "आज के लिए इतनी पेशकश काफ़ी है। कल फिर कोशिश करें।",
    "qr.household_limit": "{name} को आज बहुत पेशकश मिल चुकी हैं। कल फिर कोशिश करें।",
    "qr.blocked": "आपने इस व्यक्ति को ब्लॉक किया है।",
    "qr.not_household": "काम की पेशकश सिर्फ़ घरों को जाती है।",
    "qr.no_server": "यह ऐप GigSync के सर्वर तक नहीं पहुँच पा रहा।",
    "qr.not_found": "इस पेशकश का जवाब पहले ही दिया जा चुका है।",
    "qr.offers": "काम की पेशकश",
    "qr.offer_line": "{name} ({trade}) आपके लिए काम करना चाहते हैं",
    "qr.offer_ask": "पूछें",
    "qr.offer_not_now": "अभी नहीं",
};
//# sourceMappingURL=qr.js.map